import styles from './Spinner.module.scss';

export default function Spinner() {
  return (
    <div className={styles.wrapper} data-testid="spinner">
      <span className="fa-solid fa-spinner fa-spin" />
    </div>
  );
}
